import { createSlice } from "@reduxjs/toolkit";
import { ProfilesStateProps } from "../interfaces/profiles";

const initialState: ProfilesStateProps = {
    list: {
        fetching: "unknown",
        data: [],
        total: 0,
        error: ""
    }
};

const profilesSlice = createSlice({
    name: "profiles",
    initialState,
    reducers: {
        getProfilesRequest: (state) => {
            state.list.fetching = "loading";
        },
        getProfilesSuccess: (state, action) => {
            state.list.fetching = "success";
            state.list.data = action.payload.profiles;
            state.list.total = action.payload.total;
        },
        getProfilesFailure: (state, action) => {
            state.list.fetching = "failure";
            state.list.error = action.payload;
        },
        cleanGetProfiles: (state) => {
            state.list.fetching = initialState.list.fetching;
        }
    },
});

export const {
    getProfilesRequest,
    getProfilesSuccess,
    getProfilesFailure,
    cleanGetProfiles
} = profilesSlice.actions;

export default profilesSlice.reducer;
